import equal from "deep-equal";
import { throttle } from 'throttle-debounce';
export const controlPointer = (scene, camera, castRay) => {
  
  let timerId;
    // Debounce function: Input as function which needs to be debounced and delay is the debounced time in milliseconds

  const cameraPosition = () => [
    camera.position.x,
    camera.position.y,
    camera.position.z,
    camera.rotation.x,
    camera.rotation.y,
    camera.rotation.z
  ];
  let oldPosition = cameraPosition();

  const checkIfCameraMoved = () => {
    const newPosition = cameraPosition();
    // if (!camera.position.equals(oldCamPosition)) {
    if (!equal(newPosition, oldPosition)) {
      if(castRay({runCallbacks: false})) {
          document.getElementById("kohdistin1").style.display = "none"
          document.getElementById("kohdistin3").style.display = "block"
        } else {
          document.getElementById("kohdistin3").style.display = "none"
          document.getElementById("kohdistin1").style.display = "block"
        }
      oldPosition = cameraPosition();
    }
  }
  const throttleFunc = throttle(100, () => {
    checkIfCameraMoved()
});

  scene.onBeforeRenderObservable.add(() => {
  
    throttleFunc();
  });
};
